<template functional>
  <vs-dropdown
    vs-trigger-click
    class="cursor-pointer"
    :class="data.staticClass"
  >
    <feather-icon
      icon="MoreVerticalIcon"
      svgClasses="w-6 h-6 text-grey"
    ></feather-icon>
    <vs-dropdown-menu class="w-34">
      <vs-dropdown-item
        v-if="!props.isOfficeDocument"
        @click="
          listeners.vesselDocumentsAction
            ? {
                vesselDocumentsAction: listeners.vesselDocumentsAction(
                  'preview'
                )
              }
            : null
        "
      >
        <span class="flex items-center">
          <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>プレビュー</span>
        </span>
      </vs-dropdown-item>

      <vs-dropdown-item
        @click="
          listeners.vesselDocumentsAction
            ? { vesselDocumentsAction: listeners.vesselDocumentsAction('edit') }
            : null
        "
      >
        <span class="flex items-center">
          <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>編集</span>
        </span>
      </vs-dropdown-item>

      <vs-dropdown-item
        v-if="!props.isOfficeDocument"
        @click="
          listeners.vesselDocumentsAction
            ? {
                vesselDocumentsAction: listeners.vesselDocumentsAction('print')
              }
            : null
        "
      >
        <span class="flex items-center">
          <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>プリント</span>
        </span>
      </vs-dropdown-item>

      <vs-dropdown-item
        @click="
          listeners.vesselDocumentsAction
            ? {
                vesselDocumentsAction: listeners.vesselDocumentsAction(
                  'download'
                )
              }
            : null
        "
      >
        <span class="flex items-center">
          <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>ダウンロード</span>
        </span>
      </vs-dropdown-item>

      <vs-dropdown-item
        @click="
          listeners.vesselDocumentsAction
            ? {
                vesselDocumentsAction: listeners.vesselDocumentsAction('delete')
              }
            : null
        "
      >
        <span class="flex items-center">
          <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
          <span>削除</span>
        </span>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>
<script>
export default {
  props: {
    isOfficeDocument: { type: Boolean, required: true }
  },
};
</script>
<style lang="scss">
.w-34 {
  width: 10rem !important;
}
</style>
